import { Injectable } from '@angular/core';
import { baseURL, timeoutTime } from '../config';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/timeoutWith';
import 'rxjs/add/operator/timeout';

@Injectable({
  providedIn: 'root'
})
export class CmsService {

  baseUrl = baseURL;
  constructor(private httpClient: HttpClient) {
  }

  getLanguage(): string {
    return window.localStorage.getItem('app_language') || 'fr';
  }

  getallcountry(): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const params = new HttpParams().set('language', this.getLanguage());
    return this.httpClient.post(this.baseUrl + `country/list`, {}, { headers, params })
      .timeoutWith(timeoutTime, Observable.throw(new Error('Timeout error getallcountry')));
  }

  getallcities(id): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const params = new HttpParams().set('language', this.getLanguage());
    return this.httpClient.post(this.baseUrl + `city/list/${id}`, {}, { headers, params })
      .timeoutWith(timeoutTime, Observable.throw(new Error('Timeout error getallcities')));
  }

  aboutusactivedata() {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const params = new HttpParams().set('language', this.getLanguage());
    return this.httpClient.post(this.baseUrl + `aboutus/active_data`, {}, { headers, params });
  }
  privacyctivedata() {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const params = new HttpParams().set('language', this.getLanguage());
    return this.httpClient.post(this.baseUrl + `privacypolicy/active_data`, {}, { headers, params });
  }
  termsactivedata() {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const params = new HttpParams().set('language', this.getLanguage());
    return this.httpClient.post(this.baseUrl + `termsofservice/active_data`, {}, { headers, params });
  }

  pricingdata() {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const params = new HttpParams().set('language', this.getLanguage());
    return this.httpClient.post(this.baseUrl + `pricing/active_data`, {}, { headers, params });
  }

  createmanager(managerdata): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const params = new HttpParams().set('language', this.getLanguage());
    return this.httpClient.post(this.baseUrl + `realestatemanager/register`, managerdata, { headers, params })
      .timeoutWith(timeoutTime, Observable.throw(new Error('Timeout error createmanager')));
  }

  resentOtp(body): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const params = new HttpParams().set('language', this.getLanguage());
    return this.httpClient.post(this.baseUrl + `realestatemanager/resend_otp`, body, { headers, params })
      .timeoutWith(timeoutTime, Observable.throw(new Error('Timeout error createmanager')));
  }
}
